import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import BaseIconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const FullScreenContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  background: ${color.light};
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  padding: 20px;
`;

const SearchCompanyWrapper = styled.div`
  width: 100%;
  max-width: 600px;
`;

const ConfirmButton = styled(Button)`
  background-color: #33bc89;
  color: ${color.light};
  height: 40px;
  width: 100px;
  border: 2px solid #33bc89;
  border-radius: 3px;
  transition: opacity 0s !important;
  font-size: 16px;

  &:hover {
    background-color: #00ab6b;
    color: ${color.light};
  }
`;

const Iconmoon = styled(BaseIconmoon)`
  cursor: pointer;
  &:hover {
    color: inherit;
  }
`;

export { FullScreenContainer, SearchCompanyWrapper, ConfirmButton, Iconmoon };
